import { render, staticRenderFns } from "./editHomeWork.vue?vue&type=template&id=571b92b7&scoped=true&"
import script from "./editHomeWork.vue?vue&type=script&lang=js&"
export * from "./editHomeWork.vue?vue&type=script&lang=js&"
import style0 from "./editHomeWork.vue?vue&type=style&index=0&id=571b92b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571b92b7",
  null
  
)

export default component.exports